import React from "react";

// Assets
import Logo from "../assets/logo.png";

// Assets
import { IconContext } from "react-icons/lib";

// Components
import { SideBarData } from "./sideBarData";
import SubMenu from "./subMenu";
import { useAuth } from "../Context/AuthContext";

const SideBar = () => {
  const Auth = useAuth();
  const roles = Auth.getUserRole();
  const isAdmin = Auth.isAdminRole();

  return (
    <IconContext.Provider value={{ color: "#009cff" }}>
      <nav className="flex flex-col h-full bg-white border-r border-gray-100">
        <div className="flex items-center px-5 py-5 border-b border-gray-100">
          <img src={Logo} alt="logotipo" className="h-8 w-auto" />
        </div>

        {SideBarData.filter(
          (item) => item.isAdminRoute === isAdmin && item.roles.includes(roles),
        ).map((item, index) => {
          return <SubMenu item={item} key={index} />;
        })}
      </nav>
    </IconContext.Provider>
  );
};

export default SideBar;
